export const dayTours = [
  {
  id: "jozani",
  title: "Jozani Forest Excursion – A Journey into Zanzibar’s Wild Heart",
  location: "Jozani National Park",
  shortDescription: "Explore the red colobus monkeys, mangroves, and nature trails.",
  longDescription: `Jozani Forest Excursion
A Journey into Zanzibar’s Wild Heart

Discover the natural beauty of Zanzibar with an unforgettable excursion to Jozani Forest, the island’s only national park. This lush tropical forest is home to a unique ecosystem and some of the most fascinating wildlife in Tanzania.

- What to Expect:

✅ Encounter the Rare Red Colobus Monkeys

✅ Jozani Forest is famous for being the last sanctuary of the Zanzibar Red Colobus Monkey, an endangered species found only on the island. These playful and friendly primates are known for their striking red and black fur and curious nature.

✅ Walk Through the Enchanting Mahogany Forest

✅ Stroll along shaded nature trails surrounded by towering mahogany and eucalyptus trees. 

The forest is rich in biodiversity, offering a peaceful escape into nature.

Explore the Mangrove Ecosystem
A wooden boardwalk takes you through the mangrove swamp, an essential habitat for marine life and a natural protector against coastal erosion. Observe the intricate root systems and spot crabs and small fish thriving in the brackish waters.

Learn About the Medicinal Plants
Your guide will introduce you to the various indigenous plants traditionally used for healing by local communities.

Tour Details:

✅ Location: Jozani Chwaka Bay National Park, Zanzibar

✅ Duration: Approximately 2–3 hours

- What to Bring: 

✅ Comfortable walking shoes

✅ sunscreen

✅ insect repellent, and 

✅ A camera

This guided tour offers a perfect balance of adventure, wildlife observation, and ecological discovery.

🌴 Experience the real Zanzibar with a local! 🌍✨`,
  image: "/images/colobus monkey.jpg",
  cta: { label: "Read More", href: "/day-tours/jozani" },
  type: "dayTours",
  rating: 5,
  price: {
    type: "standard",
    packages: {
      "adult": 40,
      "child": 25
    },
    note: "Entrance fees included, professional guide"
  }
},

  {
    id: "kizimkazi-dolphin",
    title: "Dolphin Experience & Snorkeling Tour",
    location: "Mnemba Island",
    shortDescription:
      "Early-morning ocean experience with dolphin observation and snorkeling.",
    longDescription: `

Embark on a magical journey to Mnemba Island, one of Zanzibar’s most secluded and breathtaking marine sanctuaries. This tour offers an ethical and awe-inspiring dolphin encounter amidst crystal-clear waters, turquoise lagoons, and vibrant coral reefs.

Set sail from the coast and glide across calm, sparkling seas where bottlenose and humpback dolphins are often seen dancing alongside your boat. Expert local guides follow responsible wildlife practices, ensuring you enjoy these incredible creatures without disturbing their natural habitat.

Arriving at Mnemba Island, immerse yourself in the rich underwater world. Snorkel among colorful coral gardens teeming with tropical fish, sea urchins, and graceful rays. The island’s protected waters create perfect conditions for both beginners and seasoned snorkelers, making every moment magical.

Beyond the water, take in Mnemba Island’s pristine beaches and untouched beauty a serene escape where turquoise meets white sand, framed by swaying palms. This experience blends adventure, learning, and relaxation, offering travelers a true taste of Zanzibar’s marine paradise.

    `,
    image: "/images/kizimkazidolphintour.avif",
    cta: { label: "Read More", href: "/day-tours/kizimkazi-dolphin" },
    type: "dayTours",
    rating: 5
  },

  {
    id: "nakupenda",
    title: "Nakupenda Sandbank Experience",
    location: "Near Stone Town",
    shortDescription:
      "Relax on a stunning white-sand sandbank surrounded by turquoise waters.",
    longDescription: `
Nakupenda Sandbank is one of Zanzibar’s most breathtaking natural attractions. Located just offshore from Stone Town, this temporary island appears during low tide, forming a pristine stretch of white sand surrounded by crystal-clear waters.

The experience offers plenty of time for swimming, snorkeling, sunbathing, and relaxation. The shallow waters make it safe and enjoyable for visitors of all ages, while the open ocean views provide exceptional photo opportunities.

Nakupenda is perfect for couples, families, and small groups seeking a peaceful escape and a true island atmosphere. The focus of this tour is simplicity, natural beauty, and relaxation.

📲 Booking & Prices:  
Click Ask for Price / Book Tour to receive full details on WhatsApp.
    `,
    image: "/images/nakupendasandbank.jpg",
    cta: { label: "Read More", href: "/day-tours/nakupenda" },
    type: "dayTours",
    rating: 5
  },

  {
    id: "prison-island",
    title: "Prison Island & Giant Tortoise Tour",
    location: "Changuu Island",
    shortDescription:
      "Visit historic ruins and meet giant Aldabra tortoises.",
    longDescription: `
Prison Island, also known as Changuu Island, is a short boat ride from Stone Town and offers a unique mix of history, wildlife, and relaxation. Originally intended as a detention site, the island is now best known for its population of giant Aldabra tortoises.

Visitors can observe and learn about these remarkable creatures, some of which are over a hundred years old. The island also features historic ruins that reflect Zanzibar’s colonial past.

There is free time to swim, relax along the shoreline, or explore the island at your own pace. This tour is ideal for families, history enthusiasts, and travelers looking for a short yet enriching island experience.

📲 Booking & Prices:  
Use the Ask for Price / Book Tour button to contact us.
    `,
    image: "/images/prison.jpg",
    cta: { label: "Read More", href: "/day-tours/prison-island" },
    type: "dayTours",
    rating: 4
  },

  {
  id: "safari-blue",
  title: "Safari Blue – The Ultimate Zanzibar Adventure",
  location: "Kwale Island",
  shortDescription: "Dhow sailing, snorkeling, seafood lunch, sandbank relaxation, and dolphin spotting.",
  longDescription: `Safari Blue – The Ultimate Zanzibar Adventure

Embark on a once-in-a-lifetime journey with Safari Blue, the most famous sea excursion in Zanzibar! Explore the stunning waters, breathtaking islands, and rich marine life of the Menai Bay Conservation Area on a traditional local boat.

- What’s Included?

Sailing on a Traditional Local Boat
Glide across the turquoise waters aboard an authentic Zanzibar dhow for a unique and immersive experience.

🐠 Snorkeling in Crystal-Clear Waters
Dive into Zanzibar’s best snorkeling spots, exploring vibrant coral reefs filled with tropical fish. Suitable for both beginners and experienced snorkelers.

🏝️ Sandbank Relaxation & Swimming
Stop at a pristine sandbank, relax under the sun, and swim in the warm, shallow waters.

🍽️ Seafood Feast on Kwale Island
Enjoy a Swahili-style seafood lunch featuring grilled fish, lobster, calamari, and fresh tropical fruits under the shade of baobab trees.

🐬 Dolphin Spotting
Look out for playful dolphins swimming alongside your boat—an unforgettable experience.

🌿 Mangrove Forest Exploration
Visit a unique mangrove lagoon and float through calm waters surrounded by lush forests.

- Why Choose Safari Blue?

✅ Most famous and highly-rated sea excursion in Zanzibar

✅ Perfect for families, couples, and adventure seekers

✅ Stunning locations with professional guides

✅ Full-day experience packed with activities and relaxation

✨ Join us for an unforgettable day in paradise! ✨

📅 Book your Safari Blue excursion today via WhatsApp +255 682 837 935.

`,
  image: "/images/safariblue.jpg",
  cta: { label: "Read More", href: "/day-tours/safari-blue" },
  type: "dayTours",
  rating: 5,
  price: {
    type: "mixed",
    packages: {
      private: {
        "2_people": 210,
        "3_people": 260,
        "4_people": 310
      },
      shared: {
        "2_people": 100,
        "3_people": 150,
        "4_people": 200
      }
    },
    note: "Round-trip taxi included for both private and shared tours."
  }
},
{
  id: "seaweed-center",
  title: "Seaweed Farming & Community Tour",
  location: "Paje Village",
  shortDescription:
    "Learn about seaweed farming and women-led cooperatives in Zanzibar.",
  longDescription: `
This educational and cultural tour takes place in the coastal village of Paje, where seaweed farming has been a vital source of income for local women for generations. The tour offers a unique opportunity to understand how seaweed is cultivated, harvested, and processed using traditional methods.

Guided by members of the local community, visitors walk through the shallow tidal farms and learn about the economic, environmental, and social importance of seaweed production. The experience highlights women empowerment, sustainability, and community resilience.

This tour is ideal for travelers interested in responsible tourism, cultural exchange, and learning directly from local people.

📲 Booking & Prices:  
Click Ask for Price / Book Tour to receive details via WhatsApp.
  `,
  image: "/images/seaweed.jpg",
  cta: { label: "Read More", href: "/day-tours/seaweed-center" },
  type: "dayTours",
  rating: 4
},

{
  id: "stone-town",
  title: "Stone Town Historical City Tour",
  location: "Stone Town",
  shortDescription:
    "Discover Zanzibar’s UNESCO-listed old town with a local guide.",
  longDescription: `
Stone Town is the cultural and historical heart of Zanzibar and a UNESCO World Heritage Site. This guided walking tour takes you through narrow alleys, lively markets, historic buildings, and iconic landmarks that reflect centuries of Arab, African, Indian, and European influence.

Highlights include historic doors, former sultan palaces, old mosques, churches, and local markets where daily life unfolds. Your guide provides rich storytelling about Zanzibar’s trade history, architecture, and cultural traditions.

This tour is perfect for first-time visitors who want a deep understanding of Zanzibar’s identity and heritage.

📲 Booking & Prices:  
Use the Ask for Price / Book Tour button to contact us.
  `,
  image: "/images/stonetown.jpg",
  cta: { label: "Read More", href: "/day-tours/stone-town" },
  type: "dayTours",
  rating: 4
},

{
  id: "sunset-dhow",
  title: "Sunset Dhow Cruise",
  location: "Nungwi Coast",
  shortDescription:
    "Enjoy a relaxing sunset sail aboard a traditional wooden dhow.",
  longDescription: `
Sunset Dhow Cruise – Nungwi’s Magical Evening

Set sail from the northern tip of Zanzibar in Nungwi and immerse yourself in a truly unforgettable sunset experience. Board a traditional wooden dhow and glide along the sparkling turquoise waters as the sun dips below the horizon, painting the sky in shades of gold, pink, and lavender.

✅ Romantic Golden Hour
The calm evening seas and gentle breeze create the perfect atmosphere for couples, honeymooners, and anyone seeking a serene escape. Watch as the light dances across the water, offering a magical backdrop for photos and cherished memories.

✅ Traditional Sailing Experience
Feel the authenticity of a classic Zanzibar dhow as you sail along Nungwi’s pristine coastline. Our skilled crew ensures a smooth, safe, and relaxing journey while sharing fascinating stories of local culture and maritime traditions.

✅ Refreshments & Relaxation
Enjoy light refreshments on board while you unwind, sip tropical drinks, and take in panoramic ocean views. Let the peaceful rhythm of the waves wash away the stresses of everyday life.

✅ Perfect for Photographers & Nature Lovers
Capture the stunning interplay of sun, sea, and sky, and spot playful seabirds skimming the water. The calm conditions make it ideal for both casual snapshots and professional photography.

✨ An Evening to Remember
This Nungwi sunset cruise is more than a tour—it’s an intimate journey into Zanzibar’s beauty, where every moment invites you to relax, reflect, and connect with nature.


📲 Booking & Prices:
Click Ask for Price / Book Tour to receive details on WhatsApp.
  `,
  image: "/images/sunset.jpg",
  cta: { label: "Read More", href: "/day-tours/sunset-dhow" },
  type: "dayTours",
  rating: 5
},

{
  id: "tumbatu-village",
  title: "Tumbatu Island Cultural Village Tour",
  location: "Tumbatu Island",
  shortDescription:
    "Experience traditional village life on one of Zanzibar’s least-visited islands.",
  longDescription: `
Tumbatu Island offers a rare opportunity to experience traditional Zanzibari culture far from mass tourism. This guided cultural tour introduces visitors to village life, customs, and daily routines that have remained largely unchanged for generations.

Guests explore the village, interact with local residents, and learn about traditional housing, farming, and community values. The tour emphasizes respectful cultural exchange and authentic interaction.

This experience is ideal for culturally curious travelers seeking something truly unique.

📲 Booking & Prices:  
Use the Ask for Price / Book Tour button to contact us.
  `,
  image: "/images/tumbatu.jpg",
  cta: { label: "Read More", href: "/day-tours/tumbatu-village" },
  type: "dayTours",
  rating: 4
},

{
  id: "slave-trade",
  title: "Zanzibar Slave Trade & Mangapwani Caves Tour",
  location: "Mangapwani",
  shortDescription:
    "Explore historical sites connected to Zanzibar’s slave trade history.",
  longDescription: `
This powerful and educational tour explores the historical sites associated with Zanzibar’s role in the East African slave trade. Visitors are guided through Mangapwani slave caves and surrounding areas used to hide enslaved people during the abolition period.

Through detailed storytelling, the guide explains the historical context, human impact, and lasting legacy of slavery in Zanzibar. This tour is designed to educate, commemorate, and encourage reflection.

It is ideal for travelers interested in history, culture, and meaningful learning experiences.

📲 Booking & Prices:  
Click Ask for Price / Book Tour to receive details via WhatsApp.
  `,
  image: "/images/slave.jpg",
  cta: { label: "Read More", href: "/day-tours/slave-trade" },
  type: "dayTours",
  rating: 4
},

{
  id: "spice",
  title: "Spice Farm Excursion – A Journey Through the Flavors of Nature",
  location: "Spice Farms, Zanzibar",
  shortDescription: "Discover exotic spices, taste tropical fruits, and learn traditional herbal remedies.",
  longDescription: `Spice Farm Excursion – A Journey Through the Flavors of Nature

Embark on a sensory adventure with our Spice Farm Excursion, where you will discover the rich world of exotic spices, their fascinating history, and their incredible benefits.

- What to Expect:

✅Guided Tour of the Plantation

✅ Walk through lush spice gardens with a knowledgeable guide who will introduce you to the origins and uses of cinnamon, vanilla, nutmeg, cardamom, and many other aromatic treasures.

✅ Interactive Experience
Smell, touch, and taste fresh spices straight from the plants as you learn about their culinary and medicinal properties.

✅ Exotic Fruits Tasting
Enjoy a selection of tropical fruits picked fresh from the farm, such as mangoes, passion fruits, and jackfruits, for an authentic taste of nature.

✅ Traditional Herbal Remedies
Discover how local communities use these natural ingredients for well-being, beauty, and traditional healing practices.

✅ Optional Cooking Demonstration
For those who love to cook, watch a live demonstration on how to use these spices to prepare flavorful local dishes.

- Who is this excursion for?

This experience is perfect for:

✅ Food lovers, nature enthusiasts, and anyone curious about the origins of the world’s most beloved flavors. Whether you’re a seasoned chef or simply enjoy discovering new cultures, the Spice Farm tour is an unforgettable journey for all senses.

Practical Information:

✅ Location: Spice Farm, Zanzibar

✅ Duration: Approximately 2–3 hours

✅ Availability: Daily, with multiple departure times

- What to Bring: 

✅ Comfortable walking shoes,

✅ A hat, and 

✅ A camera to capture the vibrant colors of the spice farm.

📅 Book your Spice Farm excursion today! Contact us via WhatsApp at +255 682 837 935.

🌴 Experience the real Zanzibar with a local!`,
  image: "/images/spice.jpg",
  cta: { label: "Read More", href: "/day-tours/spice" },
  type: "dayTours",
  rating: 3,
  price: {
    type: "perPerson",
    packages: {
      adult: 35,
      child: 20
    },
    note: "Price includes guided tour and fruit tasting. Optional cooking demo extra."
  }
},

{
  id: "blue-lagoon",
  title: "Blue Lagoon Snorkeling Tour",
  location: "Southeast Coast, Zanzibar",
  shortDescription: "Crystal-clear lagoon snorkeling with coral reefs and marine life.",
  longDescription: `Blue Lagoon
Discover the Blue Lagoon – A Hidden Gem in Zanzibar (Le Joyau caché de Zanzibar)

Embark on an unforgettable adventure to Zanzibar’s Blue Lagoon, a breathtaking marine sanctuary located on the island’s southeast coast. This excursion is perfect for those seeking a unique snorkeling experience in crystal-clear waters, surrounded by vibrant coral reefs and exotic marine life.

- What to Expect:

✅ Snorkeling in Pristine Waters
Dive into the turquoise lagoon and explore a mesmerizing underwater world filled with colorful fish, starfish, and stunning coral formations. The calm and shallow waters make it ideal for both beginners and experienced snorkelers.

✅ Traditional Local Boat Ride
Experience the charm of a traditional local boat across the lagoon while enjoying the serene beauty of the Indian Ocean.

✅ Relaxation & Coastal Beauty
After snorkeling, unwind on the white sandy beaches, soak up the sun, and enjoy the tranquil atmosphere of this hidden paradise.

✅ Optional Add-ons
Enhance your experience with a delicious seafood lunch by the shore or a visit to nearby attractions like The Rock Restaurant or the Jozani Forest.

-Why Choose the Blue Lagoon?

✅ Stunning coral reef ecosystem

✅ Perfect for snorkeling and swimming

✅ Off the beaten path – a true Zanzibar gem

✅ Ideal for couples, families, and adventure seekers

Join us for an unforgettable day in paradise!

Ready to dive into paradise? Book your Blue Lagoon excursion now and create unforgettable memories in Zanzibar! This tour can be organized as a private group or shared with other people. For more information or direct booking, please contact us through WhatsApp +255 682 837 935 or via social media (links at the top of the page).

`,
  image: "/images/bluesnork.jpg",
  cta: { label: "Read More", href: "/day-tours/blue-lagoon" },
  type: "dayTours",
  rating: 5,
  price: {
    type: "shared",
    packages: {
      "2_people": 90,
      "3_people": 120,
      "4_people": 150
    },
    note: "Round-trip taxi included"
  }
},

{
  id: "south-zanzibar",
  title: "South of Zanzibar – Discover Southern Zanzibar with Haji",
  location: "Southern Zanzibar",
  shortDescription: "Explore untouched beaches, local villages, and swim with turtles.",
  longDescription: `South of Zanzibar
Discover Southern Zanzibar with Haji

Explore the authentic beauty of southern Zanzibar on an exclusive guided tour with Haji, your expert local guide. With his deep knowledge of the island’s history, culture, and hidden gems, Haji will take you on an unforgettable journey through Zanzibar’s untouched landscapes and vibrant traditions.

- What to Expect:

✅ Breathtaking Southern Beaches
Step onto the untouched, white-sand beaches of the south, where the turquoise waters of the Indian Ocean meet the endless horizon. Relax, take in the serene atmosphere, and capture the natural beauty of this paradise.

✅ Traditional Zanzibari Village Visit
Experience the heart of Zanzibari culture with a visit to a local village. Walk through the community, meet the friendly locals, and gain insight into their daily lives. Haji will introduce you to traditional craftsmanship, farming techniques, and the unique customs that shape this peaceful way of life.

✅ Swim with Turtles
Get up close with Zanzibar’s incredible marine life as you swim with majestic sea turtles in their natural environment. This unique experience allows you to observe these gentle creatures up close while learning about conservation efforts to protect them.

✅ Lunch Options – Authentic Swahili Meal or The Rock Restaurant
Enjoy a delicious Swahili meal prepared with fresh, locally sourced ingredients, featuring Zanzibar’s signature flavors.

✅ Optional: Lunch at The Rock Restaurant
For an exclusive culinary experience, opt for lunch at The Rock, one of Zanzibar’s most iconic restaurants. Located on a rock in the Indian Ocean, this unique dining spot offers stunning views and exquisite seafood dishes. (Advance booking required – additional cost applies.)

✅ A Journey Off the Beaten Path
This tour is perfect for travelers seeking an intimate and immersive experience away from the crowds. Haji’s passion for his homeland will make you feel like a true explorer, uncovering Zanzibar’s best-kept secrets.


✅ Duration: Full-day tour

✅Includes: Private guide, transport, lunch (Swahili meal included, The Rock optional at extra cost)

📅 Book your Southern Zanzibar excursion today! Contact us via WhatsApp at +255 682 837 935.

🌴 Experience the real Zanzibar with a local! 🌍✨`,
  image: "/images/south.jpg",
  cta: { label: "Read More", href: "/day-tours/south-zanzibar" },
  type: "dayTours",
  rating: 5,
  price: {
    type: "private",
    packages: {
      "1_2_people": 180,
      "3_4_people": 240,
      "5_6_people": 300
    },
    note: "Swahili lunch included, The Rock optional"
  }
}
];
